﻿$(function () {
	$(document).on('click', 'a', event => {
		let href = $(event.currentTarget).attr('href').trim();
		let isBlank = $(event.currentTarget).hasClass('blank');

		if (href === '#' || href === '' || isBlank) {
			event.preventDefault();
		}

		if (href !== '#' && href !== '' && isBlank) {
			let site = window.open(href);
			site.focus();
		}
	});

	$.each($('.code-highlight'), (_, el) => {
		let block = $(el);
		let file = block.data('file');
		if (file) {
			let link = null;
			if (file.startsWith('/')) {
				link = AMWD.Url + file;
			}
			//else if (file.startsWith('http')) {
			//	link = file;
			//}
			else {
				link = AMWD.Url + '/' + file;
			}

			$.get(link, response => {
				block.text(response.trim());
				hljs.highlightBlock(el);
			});

			block.removeData('file');
		}
		else {
			block.text(block.text().trim());
			hljs.highlightBlock(el);
		}
	});

	$('.navbar-toggler').on('click', event => {
		event.preventDefault();
		$('#main').addClass('dimmed');
		$('.side-nav').addClass('toggled');

		$('#overlay').on('click', ev => {
			ev.preventDefault();
			$('#overlay').off('click');
			$('.side-nav').removeClass('toggled');
			$('#main').removeClass('dimmed');
		});
	});

	$(document).on('click', '.alert-click-dismiss', event => {
		event.preventDefault();
		$(event.currentTarget).remove();
	});

	$(window).on('scroll', function () {
		clearTimeout(windowScrollInitTimeout);
		if (!mouseMove) {
			$(window).on('scroll', function () {
				updateLinks();
			});
		}

		let bottomPosition = $(window).scrollTop() + $(window).height();
		let footerBegin = $('#footer').position().top;

		let distance = bottomPosition - footerBegin;
		if (distance < 0) {
			$('.grecaptcha-badge').css('bottom', '14px');
		}
		else {
			$('.grecaptcha-badge').css('bottom', distance + 14 + 'px');
		}
	});
	$(window).on('mousemove', function () {
		updateLinks();
	});

	AMWD.initOutlineBadge();

	let mouseMove = false;
	let windowScrollInitTimeout = setTimeout(function () {
		$(window).trigger('scroll');
	}, 500);

	let updateLinks = function () {
		if (!mouseMove) {
			mouseMove = true;
			$.each($('.mail'), function (_, el) {
				el = $(el);
				let name = el.data('name');
				let domain = el.data('direction');
				let tld = el.data('appendix');
				let mail = name + '@' + domain + '.' + tld;
				el.attr('href', 'mailto:' + mail).text(mail);
			});
		}
	};
});
